/* eslint-disable no-unused-vars */
import React from "react";
import { FormGroup, Modal, ModalHeader, ModalFooter, ModalBody, Badge } from "reactstrap";
import DataTable from "react-data-table-component";
import CloseButton from "react-bootstrap/CloseButton";
import SpinnerButton from "../../../components/Button";
import useFetcher from "../../../hooks/useFetcher";
import { getSubclientesCentralizados } from "../../../services/subclientesServices";
import { BlurSpinner } from "../../../components/BlurSpinner";

const ConfirmCentralizado = ({ toggle, isLoading, handleSubmit, ClientId, area, areaColor }) => {
  const [subclientesCentralizados, isLoadingSubclientesCentralizados] = useFetcher(getSubclientesCentralizados, [area, ClientId]);

  return (
    <>
      <BlurSpinner isLoading={isLoadingSubclientesCentralizados}>
        {subclientesCentralizados && (
          <Modal centered backdrop="static" isOpen toggle={toggle}>
            <FormGroup>
              <ModalHeader toggle={toggle}> Detalle Centralizador </ModalHeader>
              <ModalBody className="modal-body">
                <h1 className="title-atencion">¡Atención!</h1>
                <p className="disclaimer">Los cambios en campos CENTRALIZADOS se aplicarán también a los siguientes Subclientes:</p>
                <DataTable
                  striped
                  data={subclientesCentralizados}
                  columns={[
                    {
                      name: "Subcliente",
                      selector: (row) => row.numeroDeLegajo.replace(".0000", "").padStart(7, 0),
                      center: true,
                      id: "subcliente",
                    },
                    {
                      name: "Centralizador",
                      selector: () => (
                        <Badge tag="div" className="badge-pills" style={{ backgroundColor: `${areaColor}`, padding: "4px", borderRadius: "8px" }}>
                          {area.charAt(0).toUpperCase() + area.slice(1)} <CloseButton className="badge-close-button" data-tag="allowRowEvents" />
                        </Badge>
                      ),
                      center: true,
                      id: "centralizador",
                    },
                  ]}
                />
              </ModalBody>
              <ModalFooter>
                <div className="mb-0 px-3 w-100 d-flex justify-content-between">
                  <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
                    Cancelar
                  </SpinnerButton>
                  <SpinnerButton isLoading={isLoading} className="btn btn-primary" type="button" onClick={handleSubmit}>
                    Confirmar
                  </SpinnerButton>
                </div>
              </ModalFooter>
            </FormGroup>
          </Modal>
        )}
      </BlurSpinner>
    </>
  );
};

export default ConfirmCentralizado;
